import http from 'api/httpClient';

export type FetchAbpYearsResponse = {
  years: string[];
};

export async function fetchAbpYears(): Promise<FetchAbpYearsResponse> {
  return http.get('/api/v1/pnl/years');
}

export type AbpLevelOption = {
  ou_code: string;
  ou_name: string;
};

export type AbpLevel = {
  id: number | string;
  name: string;
  visible?: boolean;
  selected?: string[] | null;
  options?: AbpLevelOption[];
};

export type UpdateAbpDropdownsRequest = {
  year: string;
  selection: Record<string, string[]>;
};

export type UpdateAbpDropdownsResponse = {
  levels: AbpLevel[];
};

export async function updateAbpDropdowns(payload: UpdateAbpDropdownsRequest): Promise<UpdateAbpDropdownsResponse> {
  return http.post('/api/v1/pnl/update-dropdowns', payload);
}

export type AbpTableRow = {
  MIS_Description: string;
  Total: number;
  Average: number;
  Apr: number;
  May: number;
  Jun: number;
  Jul: number;
  Aug: number;
  Sep: number;
  Oct: number;
  Nov: number;
  Dec: number;
  Jan: number;
  Feb: number;
  Mar: number;
};

export type FetchAbpDataRequest = {
  year: string;
  filters: Record<string, string[]>;
};

export type FetchAbpDataResponse = {
  rows: AbpTableRow[];
};

export async function fetchAbpData(payload: FetchAbpDataRequest): Promise<FetchAbpDataResponse> {
  return http.post('/api/v1/pnl/fetch-abp', payload);
}
